<template>
  <div class="searchInput">
    <input type="text" class="input" placeholder="想学什么？在这里搜索" v-model="input" />
    <router-link :to="{ path: '/course', query: { k: input } }" class="searchBtn" @click="updateSearchKeyword">
      <img src="../../assets/icon_search.png" />
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: ""
    }
  },
  mounted() {
    if (this.$store.state.searchKeyword != "") {
      this.input = this.$store.state.searchKeyword;
    }
  },
  methods: {
    updateSearchKeyword() {
      this.$store.commit("updateSearchKeyword", this.input);
    }
  },
}
</script>

<style spoed>
.searchInput {
  float: left;
  margin-top: 14px;
}

.searchInput .input {
  display: inline-block;
  border: 0;
  outline: 0;
  height: 36px;
  line-height: 36px;
  width: 270px;
  border: 1px solid #dedede;
  padding: 0 14px;
  font-size: 14px;
  border-radius: 2px 0 0 2px;
}

.searchInput .searchBtn {
  display: inline-block;
  width: 44px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  background-color: #003399;
  border-radius: 0 2px 2px 0;
  font-size: 14px;
  border: 1px solid #003399;
  position: absolute;
  top: 14px;
}

.searchBtn:hover {
  background-color: var(--link-hover-color2);
}

.searchBtn img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}
</style>